// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import { GoogleOAuth as GoogleOAuthClass } from './GoogleOAuth';
import { FacebookOAuth as FacebookOAuthClass } from './FacebookOAuth';
export var GoogleOAuth = new GoogleOAuthClass();
export var FacebookOAuth = new FacebookOAuthClass();
//# sourceMappingURL=index.js.map